<script>
  import HistoryAreaSection from '../EditorV2Pages/HistoryAreaSection.svelte';
  import { useEditorV2Setup } from '../EditorV2Pages/setup.js';
  useEditorV2Setup();
</script>

<HistoryAreaSection />